import qs from "qs";
import { useLocation, useNavigate } from "react-router-dom";

const QueryHook = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const query = qs.parse(location.search, { ignoreQueryPrefix: true });

	const QueryParams = query;

	const stringify = (obj: any) => qs.stringify(obj);

	const AddQueryParams = (params: any = {}) => {
		navigate(`?${qs.stringify({ ...params })}`);
	};

	const MergeQueryParams = (params: any = {}) => {
		navigate(`?${qs.stringify({ ...query, ...params })}`);
	};

	const RemoveQueryParams = (params: string[]) => {
		navigate(`?${qs.stringify(Object.fromEntries(Object.entries(query).filter(([key]) => !params.includes(key))))}`);
	};

	return { QueryParams, AddQueryParams, MergeQueryParams, RemoveQueryParams, navigate, location, stringify };
};

export default QueryHook;
